import React, { useEffect } from "react";

const CONTACT_URL = "https://www.c-metric.com/contact/";

function Enquiry() {
  useEffect(() => {
    window.location.replace(CONTACT_URL);
  }, []);

  return (
    <main className="contact-redirect">
      <div className="contact-redirect-card">
        <span className="contact-redirect-mark">A</span>
        <h1>Continue to C-Metric</h1>
        <p>Opening the C-Metric contact page so you can tell us about your workflow.</p>
        <a href={CONTACT_URL}>Go to C-Metric contact page <span>→</span></a>
      </div>
    </main>
  );
}

export default Enquiry;
